interface MessageBubbleProps {
  message: {
    id: string;
    senderId: string;
    senderName: string;
    senderRole: 'staff' | 'family' | 'system';
    content: string;
    messageType: string;
    createdAt: string;
  };
  isOwn: boolean;
}

export function MessageBubble({ message, isOwn }: MessageBubbleProps) {
  const time = new Date(message.createdAt).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  // System messages render centered
  if (message.senderRole === 'system') {
    return (
      <div className="flex justify-center my-2">
        <div className="px-3 py-1.5 bg-gray-100 rounded-full text-xs text-gray-500 italic max-w-md text-center">
          {message.content}
          <span className="ml-2 text-gray-400">{time}</span>
        </div>
      </div>
    );
  }

  const isUrgent = message.messageType === 'URGENT';
  const roleLabel = message.senderRole === 'staff' ? 'Staff' : 'Family';

  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-3`}>
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2.5 ${
          isOwn
            ? 'bg-blue-600 text-white rounded-br-md'
            : 'bg-gray-100 text-gray-900 rounded-bl-md'
        } ${isUrgent ? 'ring-2 ring-red-400' : ''}`}
      >
        {!isOwn && (
          <div className="flex items-center gap-1.5 mb-1">
            <span className="text-xs font-semibold">
              {message.senderName || 'Unknown'}
            </span>
            <span
              className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                message.senderRole === 'staff'
                  ? 'bg-purple-100 text-purple-700'
                  : 'bg-green-100 text-green-700'
              }`}
            >
              {roleLabel}
            </span>
          </div>
        )}
        {isUrgent && (
          <div className={`text-xs font-bold mb-1 ${isOwn ? 'text-red-200' : 'text-red-600'}`}>
            URGENT
          </div>
        )}
        <p className="text-sm whitespace-pre-wrap break-words">{message.content}</p>
        <div
          className={`text-[10px] mt-1 ${
            isOwn ? 'text-blue-200' : 'text-gray-400'
          } text-right`}
        >
          {time}
        </div>
      </div>
    </div>
  );
}
